import { render } from "./ProductCostDeliveryViewModal.vue?vue&type=template&id=27fade9b"
import script from "./ProductCostDeliveryViewModal.vue?vue&type=script&lang=js"
export * from "./ProductCostDeliveryViewModal.vue?vue&type=script&lang=js"

import "./ProductCostDeliveryViewModal.vue?vue&type=style&index=0&id=27fade9b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__